import React, { Component } from "react"
import { connect } from 'react-redux'

import { deleteFileAction, getFileAction } from '../../redux/actions/UploadAction'
import { msg } from '../Notifications/MsgBox'
import { MessageText } from "../../configs"
import utilityHelper from '../../helpers/helperUtil'
import FileList from '../../components/Upload/FileList'
import { UploadImageButton } from "../../components";

class UploadLisNoHead extends Component {

    constructor(props) {
        super(props)

        this.state = {
            ...props
        };
        this.onDeleteConfirm = this.onDeleteConfirm.bind(this)
    }

    onDeleteConfirm(event, item, index) {
       console.log("index   ==>" ,index)
        event.preventDefault()

        const { deleteFile } = this.props
        const updateBy = ''

        msg.showConfirm(
            "Confirm",
            "ต้องการลบรายการนี้หรือไม่",
            () => {
                msg.hideConfirm()
                //this.props.removeMR_Vendor('remove',index);
                deleteFile(item.transaction_no, item.running, updateBy)
                    .then(response => {
                        this.props.getFile(item.transaction_no)
                    })
                   if (this.props.onDeleteComplete){ 
                        this.props.onDeleteComplete(event,index);
                   }
                msg.success(MessageText.PAGE.MR.POPUP_MSG_SUCCESS_DELETE_UPLOAD)
            },
            () => {
                msg.hideConfirm()
                //this.props.onDeleteCancel(event,index);
                console.log("ยกเลิกการลบรายการ")
            },
            () => {
                //this.props.onDeleteCancel(event,index);
                console.log("ยกเลิกการลบรายการ")
            }
        )
        
    }

    getTransNo(){
        let result;
        let {transaction_no} = this.state;
        let {temp_trans_att_no} = this.props;
        result= transaction_no;
        if(transaction_no == "" || transaction_no == null || transaction_no == undefined)
            result=temp_trans_att_no;

        return result;
    }

    render() {
        const {
            viewMode,
            upload_files,
            file_category,
            isShow,
            modalId,
        } = this.props
        const transaction_no = this.getTransNo()
        let showCaption = false;
        if (isShow === undefined)
        {
            showCaption = true;
        }
        else {
            showCaption = isShow
        }
        console.log("file_category ==> ",file_category)
        const files = upload_files && upload_files.filter(file => file.file_category === file_category)

        console.log("files ==> " ,files);
        if (files.length <= 0)
        {
            return(
                   <>
              { isShow && ( 
                  <>
                  <label htmlFor="cc" className="rrs-label rrs-label-95">
                                แนบรายงานความเห็นแย้ง : </label>
                                <UploadImageButton id= "imagebutton" 
                                transaction_no={this.getTransNo()}
                                modalId={modalId}
                                viewMode={viewMode}
                                defaultFileName={'แนบรายงานความเห็นแย้ง'}
                                file_category={file_category}
                          ></UploadImageButton>
                </>
                )}    
                </>
    
            )
        }
        else{
        return (
            <>
            <div className="rrs-detail-data sp-table-container">
                    <div className="row">
                        { isShow && (
                            <>
                        <label htmlFor="cc" className="rrs-label rrs-label-95">
                                แนบรายงานความเห็นแย้ง : </label>
                                <UploadImageButton id= "imagebutton" 
                                transaction_no={this.getTransNo()}
                                modalId={modalId}
                                viewMode={viewMode}
                                defaultFileName={'แนบรายงานความเห็นแย้ง'}
                                file_category={file_category}
                          ></UploadImageButton>
                        </>
                        )}
                        <div className={"col-" + (isShow?"6":"12") + " d-table-row align-items-top"}>  
                            {
                            files && files.length > 0 && files.map((item, index) => (
                                <div className="row rrs-fine-box-10">
                                    <div className= "col-auto">
                                        <div className="btn-showhide-detail4">         
                                        <FileList 
                                        index={index} 
                                        item={item} 
                                        file_url = {item.file_url}
                                        filename={item.file_description} 
                                        onClick={(event) => this.onDeleteConfirm(event, item, index)}
                                        viewMode = {viewMode}
                                        ></FileList>
                                        </div>
                                    </div>
                                </div> 
                                    ))
                            }  
                        </div>
                    </div>
 
        </div>
        {/* <table className="sp-table table rrs-table-2">
            <thead>
                <tr className="sp-table-header">
                </tr>
            </thead>
            <tbody>

                {
                    files && files.length > 0 && files.map((item, index) => (
                        <tr key={`upload-file-${index}-${file_category}-${utilityHelper.genDateKey()}`}
                        >
                            <td>{item.file_name_original}</td>
                            {
                                viewMode || mviewMode === false && (
                                    <td className="text-center">
                                        <a href="#main" onClick={(event) => this.onDeleteConfirm(event, item, index)}>X<i className="icon btn-minusx" /></a>
                                    </td>)
                            }
                        </tr>
                    ))

                }
            </tbody>
        </table>
        */}
        </>
        )}
    }
}

const mapStateToProps = state => {
    const { MainRedux, UploadRedux } = state
    return {
        transaction_no: MainRedux.transaction_no,
        temp_trans_att_no: MainRedux.temp_trans_att_no,
        upload_files: UploadRedux.upload_files,
        mviewMode: MainRedux.viewMode,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        deleteFile: (transactionNo, fileNo, updateBy) => dispatch(deleteFileAction(transactionNo, fileNo, updateBy)),
        getFile: (transactionNo) => dispatch(getFileAction(transactionNo)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UploadLisNoHead)